
<div class="secondary-search">
    <form class="example-form">
        <mat-form-field class="example-full-width">
            <input type="tel" matInput placeholder="Search by Booking Reference">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </form>
</div>
